import PropTypes from "prop-types";
import React, { useMemo } from "react";
// @mui
import { AppBar, Divider, IconButton, Stack, Toolbar } from "@mui/material";
import { useTheme } from "@mui/material/styles";
// theme
import { bgBlur } from "src/theme/css";
// hooks
import { useOffSetTop } from "src/hooks/use-off-set-top";
import { useResponsive } from "src/hooks/use-responsive";
// components
import Image from "src/components/image";
import Logo from "src/components/logo";
//
import { AccountPopover, BalanceDisplay } from "src/layouts/_common";
import TasksPopover from "src/layouts/_common/tasks-popover";
//
import { HEADER, NAV } from "../config-layout";

// ----------------------------------------------------------------------

export default function Header({ onOpenNav, hasPayFailed, bannerHeight }) {
    const theme = useTheme();

    const smUp = useResponsive("up", "sm");
    const lgUp = useResponsive("up", "lg");

    const offsetTop = useOffSetTop(HEADER.H_DESKTOP);

    const renderContent = useMemo(() => (
        <>
            { !lgUp && (
                <IconButton onClick={ onOpenNav }>
                    <Image src="/assets/icon/navbar/ic_hamburge.svg" alt="menu" objectFit="contain" sx={ { width: 24, height: 24 } } />
                </IconButton>
            ) }

            { smUp && !lgUp && (
                <Logo sx={ { marginLeft: "12px", "& .component-image": { height: "24px" } } } />
            ) }

            <Stack
                flexGrow={ 1 }
                direction="row"
                alignItems="center"
                justifyContent="flex-end"
                spacing="8px"
            >
                <BalanceDisplay />

                <Divider orientation="vertical" sx={ { height: "20px", borderColor: "line" } } />

                <TasksPopover />

                <Divider orientation="vertical" sx={ { height: "20px", borderColor: "line" } } />

                <AccountPopover />
            </Stack>
        </>
    ), [ smUp, lgUp, onOpenNav ]);

    return (
        <AppBar
            sx={ {
                height: HEADER.H_DESKTOP_OFFSET,
                zIndex: theme.zIndex.appBar + 1,
                ...bgBlur({
                    color: theme.palette.background.default
                }),
                transition: theme.transitions.create([ "height" ], {
                    duration: theme.transitions.duration.shorter
                }),
                ...( lgUp && {
                    width: `calc(100% - ${ NAV.W_VERTICAL + 1 }px)`,
                    height: HEADER.H_DESKTOP,
                    ...( offsetTop && {
                        height: HEADER.H_DESKTOP_OFFSET
                    } )
                } ),
                top: hasPayFailed ? `${ bannerHeight }px` : 0
            } }
        >
            <Toolbar
                sx={ {
                    height: 1,
                    px: { lg: "30px" },
                    borderBottom: "1px solid #E6E6E6"
                } }
            >
                { renderContent }
            </Toolbar>
        </AppBar>
    );
}

Header.propTypes = {
    onOpenNav: PropTypes.func,
    hasPayFailed: PropTypes.bool,
    bannerHeight: PropTypes.number
};
